import styled from '@emotion/styled';
import { CreateButton } from './CreateButton';
import { Search } from './Search';

const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const Header = () => {
    return (
        <Container>
            <Search />
            <CreateButton />
        </Container>
    );
};
